import React from 'react'
import { connect } from 'react-redux'
import stylesPc from '../styles/resultContentTitleStyle'
import stylesPhone from '../styles/resultContentTitleStyleSmartPhone'

var styles;

type Props = {
    title: String;
    bgColor: String,
};

type State = {
};

class ResultContentTitle extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.containerDiv = React.createRef();
    }

    render() {
        styles = this.props.screenwidth > 400 * 2 ? stylesPc : stylesPhone;
        return (
            <div style={styles.main}>
                <div style={Object.assign({}, ...[styles.border, { background: this.props.bgColor }])} />
                <p style={Object.assign({}, ...[styles.title, { background: this.props.bgColor }])}>{this.props.title} </p>
            </div >
        );
    }
}

ResultContentTitle.defaultProps = {
    title: "結果",
}
const mapStateToProps = state => ({
    screenwidth: state.app.screenWidth,
});

export default connect(mapStateToProps)(ResultContentTitle);